export default __webpack_public_path__ + "static/media/Arrow3.168d3bff.svg";